import {
  dealTypeFromJsonQuery,
  FDealType,
  isFlat,
  isSuburban,
  offerTypeFromJsonQuery,
} from 'shared/common/packages/JsonQuery';

import { BX_HYBRID_SEARCH_EXPERIMENT } from '../constants/config';
import { IExperiment } from '../types/experiments';

export type Params = {
  jsonQuery: TJsonQuery;
  experiments: IExperiment[];
};

export function isHybridSearchRedirectNeeded({ jsonQuery, experiments }: Params): boolean {
  const dealType = dealTypeFromJsonQuery(jsonQuery);
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isCategoryValid =
    (dealType === FDealType.RentLongterm && isFlat(offerType)) ||
    (dealType === FDealType.Sale && isSuburban(offerType));

  const isHybridSearchExperimentEnabled = experiments.some(
    ({ groupName, experimentName }) =>
      experimentName === BX_HYBRID_SEARCH_EXPERIMENT && (groupName === 'B' || groupName === 'C'),
  );

  return isCategoryValid && isHybridSearchExperimentEnabled;
}
